(() => {
  if (window.itbOccasionReady) return;
  window.itbOccasionReady = true;
  const update = () => {
    const params = new URLSearchParams(window.location.search);
    const browsing = [...params].some(([key, value]) =>
      value !== '' && (key.startsWith('filter.') || key === 'sort_by' || (key === 'page' && Number(value) > 1))
    );
    document.querySelectorAll('[data-occasion-picks]').forEach(section => {
      section.hidden = browsing;
    });
  };
  document.addEventListener('collection:rerendered', update);
  window.addEventListener('popstate', update);
  update();
})();
